<template>
  <div class="eu-pt_5">
    <div class="eu-pb_4" v-for="(item, index) in items" :key="index">
      <emd-collapse :title="`${item.name || 'Item ' + (index + 1) }`" expanded>
        <template v-slot:icon v-if="items.length > 1">
          <i class="uil uil-trash-alt emd-text _color_danger icon-pointer" @click="removeItem(index)" />
        </template>
        <template v-slot:content>
          <div class="eu-flex">
            <div class="eu-flex-item eu-basis_12 eu-basis_6_md">
              <div class="emd-form-group">
                <label class="emd-label _required">{{ $t('name') }}</label>
                <input
                  :class="{'_state_error': $v.items.$each[index].name.$invalid && showFeedbacks.status }"
                  class="emd-input"
                  :value="item.name"
                  maxlength="64"
                  @input="changeItem($event, index, 'name')"
                />
                <p class="emd-input-feedback _state_error" v-if="!$v.items.$each[index].name.required && showFeedbacks.status">
                  {{ $t('hint.required') }}
                </p>
                <p class="emd-input-feedback _state_error" v-else-if="!$v.items.$each[index].name.maxLength && showFeedbacks.status">
                  {{ $t('hint.length', { length: '64' }) }}
                </p>
              </div>
            </div>
            <div class="eu-flex-item eu-basis_6 eu-basis_3_md">
              <div class="emd-form-group">
                <label class="emd-label">{{ $t('quantity') }}</label>
                <div class="eu-flex eu-align-items_center">
                  <div class="eu-flex-item">
                    <div class="emd-input-group _icon_left _icon_right">
                      <a class="emd-input-icon__link" @click="subtractQuantity(item)">
                        <i class="uil uil-minus"></i>
                      </a>
                      <input
                        :class="{'_state_error': $v.items.$each[index].default_quantity.$invalid && showFeedbacks.status}"
                        class="emd-input eu-align_center"
                        type="text"
                        v-model="item.default_quantity"
                        @input="filterCharQuantity(item)"
                      />
                      <a class="emd-input-icon__link" @click="addQuantity(item)">
                        <i class="uil uil-plus"></i>
                      </a>
                    </div>
                    <p class="emd-input-feedback _state_error" v-if="!$v.items.$each[index].default_quantity.required && showFeedbacks.status">
                      {{ $t('hint.required') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="eu-flex-item eu-basis_6 eu-basis_3_md">
              <div class="emd-form-group">
                <label class="emd-label _required">{{ $t('amount') }}</label>
                <emd-input-money
                  :money="money"
                  v-model="item.amount"
                  :class="{'_state_error': $v.items.$each[index].amount.$invalid && showFeedbacks.status}"
                  @input="changeItem($event, index, 'amount')"
                />
                <p class="emd-input-feedback _state_error" v-if="!$v.items.$each[index].amount.isNotZero && showFeedbacks.status">
                  {{ $t('hint.required') }}
                </p>
              </div>
            </div>
          </div>
            <div class="eu-flex">
              <div class="eu-flex-item eu-basis_12 eu-basis_12_md">
                <div class="emd-form-group">
                  <label class="emd-label">{{ $t('description') }} <span class="label-optional">({{ $t('optional') }})</span></label>
                  <input
                    :class="{'_state_error': $v.items.$each[index].description.$invalid && showFeedbacks.status}"
                    class="emd-input"
                    :value="item.description"
                    @input="changeItem($event, index, 'description')"
                  />
                  <p class="emd-input-feedback _state_error" v-if="!$v.items.$each[index].description.maxLength && showFeedbacks.status">
                    {{ $t('hint.length', { length: '255' }) }}
                  </p>
                </div>
              </div>
            </div>
        </template>
        <template v-slot:footer>
          <hr class="emd-divider" />
          <div class="emd-container__footer eu-py_4_md eu-px_5_md eu-justify_space-between eu-align-items_center eu-wrap">
            <span class="emd-label eu-display_inline-block subtotal-label">{{ $t('subtotal') }}</span>
            <span class="emd-text _type_caption eu-display_inline-block eu-ml_1 subtotal-value">
              {{ subtotal(item) }}
            </span>
          </div>
          <hr class="emd-divider" v-if="items.length < 10 && index === items.length-1" />
          <div class="emd-container__footer eu-pa_3 eu-px_3 eu-align-items_center eu-wrap" v-if="items.length < 10 && index === items.length-1">
            <div class="eu-flex-item eu-basis_12 eu-basis_12_md eu-align_center eu-no-margin_md">
              <a @click="addNewItem" class="add-item-button">
                <i class="uil uil-plus-circle"></i> {{ $t('addItem') }}
              </a>
            </div>
          </div>
        </template>
      </emd-collapse>
    </div>
  </div>
</template>

<script>
// import EmdContainer from '../../../components/emerald/molecules/EmdContainer.vue'
import EmdInputMoney from '@/components/project/EmdInputMoney'
import { EmdCollapse } from 'emerald-vue/src/components'
import { formatCurrency, formatToInt } from '@/utils/validations'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'Items',
  components: {
    EmdCollapse,
    EmdInputMoney
  },
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true
      },
      showError: false
    }
  },
  computed: {
    items () {
      return this.$store.getters.paymentLinkItems
    },
    showFeedbacks () {
      return this.$store.getters.showFeedbacks
    }
  },
  validations: {
    items: {
      minLength: minLength(1),
      $each: {
        name: {
          required,
          maxLength: maxLength(64)
        },
        amount: {
          required,
          isNotZero (value) {
            return value > 0
          }
        },
        default_quantity: {
          required
        },
        description: {
          maxLength: maxLength(255)
        }
      }
    }
  },
  methods: {
    filterCharQuantity (item) {
      item.default_quantity = item.default_quantity.replace(/[^\d]+/g, '')
    },
    changeItem (event, index, attribute) {
      this.$store.dispatch('UPDATE_ITEM', {
        value: attribute === 'amount' ? event : event.target?.value,
        index,
        attribute
      })

      this.$emit('formIsValid', this.$v.$invalid)
    },
    subtotal (item) {
      if (item.default_quantity && item.amount) {
        const quantity = item.default_quantity
        const amount = formatToInt(item.amount)
        const subtotal = formatCurrency((amount * quantity) / 100)

        return subtotal
      }

      return 'R$ 0,00'
    },
    addNewItem () {
      this.items.push({
        name: null,
        description: null,
        default_quantity: 1,
        amount: 'R$ 0,00'
      })
    },
    removeItem (index) {
      this.items.splice(index, 1)
    },
    subtractQuantity (item) {
      if (item.default_quantity > 1) {
        item.default_quantity -= 1
      }
    },
    addQuantity (item) {
      item.default_quantity += 1
    }
  }
}
</script>

<style scoped>
.subtotal-label{
  color: #72737A;
  font-weight: 700;
  font-size: 14px;
}

.subtotal-value {
  color: #2B2B2B;
  font-size: 18px;
  font-weight: 700;
}

.add-item-button {
  color: #72737A;
  font-weight: 700;
  cursor: pointer;
  font-size: 12px;
}

.icon-pointer {
  cursor: pointer;
}
</style>

<i18n>
{
  "pt-BR": {
    "name": "Nome",
    "quantity": "Quantidade",
    "amount": "Valor unitário",
    "description": "Descrição",
    "optional": "opcional",
    "addItem": "Adicionar outro item",
    "subtotal": "Subtotal",
    "hint": {
      "required": "Campo de preenchimento obrigatório",
      "length": "Máximo de {length} caracteres"
    }
  },
  "en-US": {
    "name": "Name",
    "quantity": "Quantity",
    "amount": "Unity value",
    "description": "Description",
    "optional": "optional",
    "addItem": "Add another item",
    "subtotal": "Subtotal",
    "hint": {
      "required": "This field is required",
      "length": "This field cannot be more than {length} characters"
    }
  }
}
</i18n>
